module.exports = __webpack_public_path__ + "static/media/active-course.33cb94cd.svg";